// src/pages/ProductDetails.jsx
import React from "react";
import im1 from "../assets/products/ADAPTOR .jpg";
import im2 from "../assets/products/EYELET 3.jpg";
import im3 from "../assets/products/FORK .jpg";
import im4 from "../assets/products/M7 GM BUSH 3.jpg";
import im5 from "../assets/products/METAL BUSH 6.jpg";
import im6 from "../assets/products/SING MBUSH.jpg";
import im7 from "../assets/products/SLEEVE 1.jpg";
import im8 from "../assets/products/TATA BALL STUD.jpg";
import im9 from "../assets/products/TELCO YELLOW 2.jpg";
import im0 from "../assets/products/TELCO BLACK 3.jpg";
import im01 from "../assets/products/YRA 2.jpg";
import im02 from "../assets/products/BANJO YELLOW.jpg";
import im03 from "../assets/products/CATERPILLAR 3.jpg";
import im04 from "../assets/products/YP8.jpg";
import im05 from "../assets/products/MOUNTING PIN 1.jpg";
import im07 from "../assets/products/STUD .jpg";
import im08 from "../assets/products/SPINDLE 3.jpg";
import im09 from "../assets/products/BALL JOINT 3.jpg";
import im00 from "../assets/products/FLANGE .jpg";
import im11 from "../assets/products/DRAIN PLUG.jpg";
import makeInIndia from "../assets/products/make-in-India-logo.jpg";
import mounting from "../assets/products/mounting.png";
import ball from "../assets/products/ball joint.png";
import stud from "../assets/products/ballstud.png";
import SLOT from "../assets/products/SLOT.png";
import d1 from "../assets/products/Flat Bevel Screw.jpg";
import d2 from "../assets/products/Internal Hex Screw.jpg";
import d3 from "../assets/products/Grub Screws.jpg";
import d4 from "../assets/products/Hex Allen Hd Screw.jpg";

// Example main showcase image (replace with your own if needed)
import stu from "../assets/products/ballstud.png";

const ProductDetails = () => {
  const products = [
    { id: 21, name: "BALL STUD", img: stud },
    { id: 22, name: "Slotted Hd screw", img: SLOT },
    { id: 23, name: "Flat Bevel Screw", img: d1 },
    { id: 24, name: "Internal Hex Screw", img: d2 },
    { id: 25, name: "Grub Screws", img: d3 },
    { id: 26, name: "Hex Allen Hd Screw", img: d4 },
    { id: 15, name: "MOUNTING PIN", img: mounting, description: "Leak-proof sealing in engines." },
    { id: 8, name: "SS BALL STUD", img: ball, description: "Used in steering mechanisms." },
    { id: 1, name: "ADAPTOR", img: im1, description: "Essential component providing stability." },
    { id: 2, name: "EYELET", img: im2, description: "For safe and secure fixings." },
    { id: 3, name: "FORK", img: im3, description: "Durable component for machinery." },
    { id: 4, name: "GM BUSH", img: im4, description: "High-strength mechanical bush." },
    { id: 5, name: "METAL BUSH", img: im5, description: "Resistant to wear and tear." },
    { id: 6, name: "SING MBUSH", img: im6, description: "Reliable industrial component." },
    { id: 7, name: "SLEEVE", img: im7, description: "Protective and supportive sleeve." },
    { id: 9, name: "BALL SOCKET YELLOW", img: im9, description: "Durable and quality-tested." },
    { id: 10, name: "BALL SOCKET BLACK", img: im0, description: "Strong and precise part." },
    { id: 11, name: "YRA", img: im01, description: "Component for robust usage." },
    { id: 12, name: "BANJO YELLOW", img: im02, description: "High-performance fitting." },
    { id: 13, name: "NICKEL BALL STUD", img: im03, description: "Heavy-duty machinery part." },
    { id: 14, name: "YP8", img: im04, description: "Engineered for performance." },
    { id: 16, name: "STUD", img: im07, description: "Precision threaded stud." },
    { id: 17, name: "SPINDLE", img: im08, description: "Critical rotating component." },
    { id: 18, name: "BALL JOINT", img: im09, description: "For smooth steering control." },
    { id: 19, name: "FLANGE", img: im00, description: "Secure connection in systems." },
    { id: 20, name: "DRAIN PLUG", img: im11, description: "Reliable fluid sealing." },
  ];

  return (
    <div className="bg-yellow-100 min-h-screen text-black">
      {/* Header */}
      <section className="px-6 sm:px-10 md:px-24 py-16 text-center">
        <h1 className="text-3xl sm:text-5xl md:text-6xl font-extrabold leading-tight">
          Our Products
        </h1>
        <p className="mt-4 text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
          Explore our products designed for diverse industrial applications.
        </p>
      </section>

      {/* Make in India Image */}
      <div className="flex justify-center items-center mb-20">
        <img src={makeInIndia} className="w-[800px] rounded-3xl" alt="make-in-india" />
      </div>

      {/* NEW Main Image + Content Section */}
      <section className="px-6 sm:px-10 md:px-24 py-12 flex flex-col md:flex-row items-center gap-10">
        <div className="md:w-1/2">
          <img
            src={stu}
            className="rounded-3xl shadow-lg w-full"
            alt="Main Showcase"
          />
        </div>
        <div className="md:w-1/2">
          <h2 className="text-2xl sm:text-3xl font-bold mb-4">BALL STUD</h2>
           <h3 className="text-2xl sm:text-3xl font-bold mb-4">Fasteners</h3>
          <p className="text-gray-700 text-lg leading-relaxed">
           We are specialized in manufacturing high-precision ball studs widely used in gas springs for Maruti Suzuki vehicles and other applications. Designed for durability, accuracy, and corrosion resistance, our ball studs deliver reliable and long-lasting performance.
          </p>
        </div>
      </section>

      {/* Product Grid */}
      <section className="px-6 sm:px-10 md:px-24 pb-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-10">
          {products.map((product) => (
            <div
              key={product.id}
              className="bg-gray-50 rounded-2xl shadow-lg p-6 flex flex-col items-center text-center transition-transform duration-300 hover:scale-105 hover:shadow-2xl group relative"
            >
              <div className="relative w-40 h-40 mb-4">
                <img
                  src={product.img}
                  alt={product.name}
                  className="w-full h-full object-cover rounded-lg shadow-md"
                />
              </div>
              <h2 className="text-xl font-bold mb-2">{product.name}</h2>
              <p className="text-gray-600 text-sm">{product.description}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ProductDetails;
